import { createFileRoute } from '@tanstack/react-router';
import { ProjectsView } from '../components/features/project/index.js';

/**
 * @graph-node {Page}
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business Logi Div看板ページ。PI Div の PMO（pi_pmot）が Logi Div の案件を横断 PMO ビューでスコープ表示する。ProjectsView に forcedDivision='log_div' を渡す
 * @graph-connects ProjectsView [calls] Logi Div スコープのプロジェクト一覧ビュー描画
 */
export const Route = createFileRoute('/projects/logi-div-board')({
  component: LogiDivBoardPage,
});

/** @graph-connects ProjectsView [calls] Logi Div スコープのプロジェクト一覧ビュー描画 */
function LogiDivBoardPage() {
  return <ProjectsView pageKey="logiDivBoard" forcedDivision="log_div" />;
}
